import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BottomMenu from '../footer/bottomMenu';
import HeaderTitle from '../assets/headerTitle';
import AvatarLetter from '../assets/avatarLetter';
import Cookies from 'universal-cookie';
import { Button, Divider, ListItem, ListItemAvatar, ListItemText, List, Avatar, Paper } from '@material-ui/core';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
const mainContainerStyle = {
    margin: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
}
const secondContainerStyle = {
    margin: '0 auto',
    display: 'block',
    maxWidth: '350px'
}
export default function MyInfo() {
    const cookies = new Cookies();
    const name = cookies.get('name');
    const email = cookies.get('email');
    const level = cookies.get('level');
    const history = useHistory();

    const logOut = () => {
        cookies.remove('name');
        cookies.remove('email');
        cookies.remove('level');
        cookies.remove('token');
        history.push('/');
    }

    const getLevel = (levelCode) => {
        switch (levelCode) {
            case '12':
                return 'Developer'
                break;
            case '11':
                return 'Admin'
                break;
            case '2':
                return 'Installer'
                break;
            case '1':
                return 'Seller'
                break;
            default:
                break;
        }
    }
    return (
        <>
            <div style={mainContainerStyle}>
                <AvatarLetter name={name} />
                <p>{name}</p>
            </div>
            <div style={secondContainerStyle}>
                <Paper>

                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar>
                                    <AdminPanelSettingsIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="User Level" secondary={getLevel(level)} />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar>
                                    <AlternateEmailIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Email" secondary={email} />
                        </ListItem>
                    </List>
                </Paper>



            </div>
            <Button onClick={logOut} style={{ display: 'block', margin: '1rem auto' }} color='primary'>Log out</Button>
            <BottomMenu />
        </>

    )
}
